import PageFadeIn from "../components/shared/PageFadeIn";
import { NavLink } from "react-router-dom";

const Home = () => {
	return (
		<PageFadeIn>
			<div className='absolute top-0 left-0 w-full h-screen pt-28 md:pt-52 md:pb-[90px] xl:pt-96 xl:pb-[130px] px-6 md:px-[162px] bg-home_mobile md:bg-home_tablet xl:bg-home_desktop bg-cover'>
				<div className='flex flex-col xl:flex-row items-center xl:justify-between'>
					<div className='flex flex-col xl:items-start'>
						<h5 className='md:text-20 font-barlow leading-19 tracking-27 text-center text-lavender uppercase'>
							So, you want to travel to
						</h5>
						<h1 className='relative my-4 md:my-6 font-bellefair text-80 md:text-150 leading-100 md:leading-150 xl:right-[10px] text-center text-white uppercase'>
							Space
						</h1>
						<p className='xl:w-450 font-barlow text-[15px] md:text-16 leading-[25px] md:leading-[28px] tracking-[1.2px] text-center xl:text-left text-lavender'>
							Let’s face it; if you want to go to space, you might as well genuinely go to outer
							space and not hover kind of on the edge of it. Well sit back, and relax because we’ll
							give you a truly out of this world experience!
						</p>
					</div>

					<NavLink to='/destination'>
						<div className='group my-20 md:mt-[156px] xl:mt-24 flex items-center justify-center'>
							<div className='w-150 h-150 md:w-60 md:h-60 xl:w-274 xl:h-274 flex items-center justify-center rounded-full bg-white'>
								<h4 className='font-bellefair text-20 md:text-32 leading-[23px] md:leading-[37px] tracking-125 md:tracking-2 uppercase'>
									Explore
								</h4>
							</div>
							<div className='absolute w-150 h-150 md:w-60 md:h-60 xl:w-274 xl:h-274 group-hover:scale-150 duration-700 rounded-full bg-border_grey opacity-30' />
						</div>
					</NavLink>
				</div>
			</div>
		</PageFadeIn>
	);
};

export default Home;
